<template>
  <header class="header landing-wrapper">
    <router-link to="/" class="header__logo">
      <Logo />
    </router-link>

    <Menu />

    <div class="header__actions">
      <Button
        type="secondary"
        v-if="!isAuth"
        class="header-btn"
        size="sm"
        left-icon="/Home/user.svg"
        @click.prevent="$store.commit('stateSignIn')"
      >
        {{ headerBtnTitle }}
      </Button>

      <div class="header-icon" v-if="!isAuth" @click="$store.commit('stateSignIn')">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.1978 14.9931C20.5771 13.9138 21.5839 12.4338 22.0781 10.759C22.5723 9.0842 22.5293 7.29786 21.9551 5.64849C21.3808 3.99913 20.304 2.56876 18.8743 1.55639C17.4446 0.544027 15.7332 0 13.9782 0C12.2231 0 10.5117 0.544027 9.082 1.55639C7.65232 2.56876 6.57546 3.99913 6.00126 5.64849C5.42705 7.29786 5.38405 9.0842 5.87822 10.759C6.3724 12.4338 7.37918 13.9138 8.75851 14.9931C6.395 15.9348 4.33276 17.4967 2.79164 19.5123C1.25051 21.528 0.288277 23.9217 0.00750971 26.4384C-0.0128137 26.6222 0.00345293 26.8081 0.0553805 26.9856C0.107308 27.1631 0.19388 27.3287 0.310153 27.4729C0.544977 27.7642 0.886526 27.9507 1.25966 27.9916C1.6328 28.0324 2.00696 27.9241 2.29983 27.6906C2.5927 27.457 2.78029 27.1174 2.82134 26.7463C3.13027 24.0111 4.44166 21.485 6.50494 19.6507C8.56823 17.8163 11.2388 16.8022 14.0063 16.8022C16.7738 16.8022 19.4444 17.8163 21.5076 19.6507C23.5709 21.485 24.8823 24.0111 25.1913 26.7463C25.2295 27.0901 25.3945 27.4076 25.6543 27.6376C25.9141 27.8675 26.2504 27.9937 26.5982 27.9916H26.7529C27.1217 27.9494 27.4588 27.7639 27.6907 27.4756C27.9226 27.1873 28.0306 26.8195 27.991 26.4524C27.7089 23.9286 26.7415 21.5287 25.1924 19.5099C23.6434 17.4912 21.5711 15.9298 19.1978 14.9931ZM13.9782 13.9996C12.8651 13.9996 11.7771 13.6714 10.8516 13.0564C9.92614 12.4414 9.20483 11.5673 8.77888 10.5446C8.35294 9.52197 8.24149 8.39664 8.45864 7.31097C8.67578 6.22531 9.21176 5.22806 9.99881 4.44533C10.7858 3.66261 11.7886 3.12957 12.8803 2.91362C13.9719 2.69766 15.1034 2.8085 16.1318 3.23211C17.1601 3.65571 18.039 4.37306 18.6574 5.29345C19.2758 6.21383 19.6058 7.29591 19.6058 8.40285C19.6058 9.88721 19.0129 11.3108 17.9575 12.3604C16.9021 13.41 15.4707 13.9996 13.9782 13.9996Z"
            fill="white"
          />
        </svg>
      </div>
      <AuthWrapper v-else />
      <div class="burger" @click.stop="$store.state.isOpenBurgerMenu = true">
        <Icon name="/base/burger.svg" />
      </div>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/Logo/Logo.vue'
import Button from '@/components/Base/Button/Button.vue'
import social from '@/mixins/social'
import Menu from '@/components/Navigation/Menu/Menu.vue'
import AuthWrapper from '@/components/Navigation/AuthWrapper/AuthWrapper.vue'
import { clickOutside } from '@/directives/clickOutside'
import { mapGetters } from 'vuex'
import Icon from '@/components/Base/Icon/Icon.vue'
import windowSize from '@/mixins/windowSize'
import ScreenSize from '@/enums/ScreenSize'

export default {
  name: 'Navigation',
  mixins: [social, windowSize],
  components: {
    Icon,
    AuthWrapper,
    Menu,
    Button,
    Logo
  },
  directives: {
    clickOutside
  },
  computed: {
    ...mapGetters(['language']),
    isRussian() {
      return this.language === 'ru'
    },
    isAuth() {
      return this.$store.state.isAuth
    },
    headerBtnTitle() {
      return this.screenWidth < ScreenSize.MOBILE_LG ? this.$t('navigation.login') : this.$t('navigation.lk')
    }
  },
  methods: {
    openUserMenu() {
      if (document.body.clientWidth <= 965) this.$store.state.isOpenUserDropMenu = true
    },
    goToTransfer() {
      if (this.$route.path === '/') window.location.replace('/')
    }
  }
}
</script>

<style lang="scss">
@import './navigation';
</style>
